import styled from 'styled-components';

export const UploadsContainer = styled.div`
  width: 100%;
  max-width: 110rem;
  margin-top: 0.6rem;
`;
